import React from 'react';
import { motion } from 'framer-motion';
import { SendIcon, PenToolIcon, RocketIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const steps = [{
  icon: SendIcon,
  title: 'Me envías tu información',
  text: 'Logo, fotos, textos y lo que quieras mostrar. Todo por WhatsApp, en 10 minutos.'
}, {
  icon: PenToolIcon,
  title: 'Diseño tu web',
  text: 'Armo el diseño a medida de tu negocio y te lo muestro para aprobar.'
}, {
  icon: RocketIcon,
  title: 'La publicamos en 24 horas',
  text: 'Dominio conectado, hosting activo y tu web online recibiendo consultas.'
}];
export function HowItWorks() {
  return <section id="como-funciona" className="w-full bg-[#FAFAFA] py-20 sm:py-28" data-id="element-114" data-mp="gtjtng58279n">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-115" data-mp="grgua5i6j1s9">
        <SectionHeading eyebrow="Cómo funciona" title="Tres pasos, un solo día" description="Un proceso simple y sin vueltas para que tu negocio esté online mañana." data-id="element-116" data-mp="14iciksnffeur" />

        <ol className="relative mt-14 grid gap-6 md:grid-cols-3" data-id="element-117" data-mp="2rmfrii6dmali">
          <div aria-hidden="true" className="absolute left-0 right-0 top-[3.75rem] hidden border-t-2 border-dashed border-brand-yellow md:block" data-id="element-118" data-mp="2mn36m2z2fdlk" />
          {steps.map((step, index) => <motion.li key={step.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative z-10 rounded-3xl border border-black/5 bg-white p-8 shadow-soft" data-id="element-119" data-mp="2wjz7pnmmwxg3" data-mpi={index}>
              <div className="flex items-center gap-4" data-id="element-120" data-mp="3fbs29mhcqqpx">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-ink text-base font-extrabold text-brand-yellow" data-id="element-121" data-mp="1pvslbj7hrwzq">
                  {index + 1}
                </span>
                <step.icon className="h-6 w-6 text-brand-ink/30" aria-hidden="true" data-id="element-122" data-mp="3l08rulkidjm3" />
              </div>
              <h3 className="mt-6 text-lg font-bold" data-id="element-123" data-mp="3pxs79osy02fm">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-ink/60" data-id="element-124" data-mp="3u05b27o4pq9r">{step.text}</p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}